import { BreakpointObserver, BreakpointState } from "@angular/cdk/layout";
import { Injectable } from "@angular/core";
import { UserData } from "@osapp/model";
import { PlatformService } from "@osapp/services";
import { BehaviorSubject, EMPTY, Observable, Subject } from "rxjs";
import { map } from "rxjs/operators";
import { EModule } from "../enums/EModule";
import { SnackbarService } from "./snackbar.service";

@Injectable({
    providedIn: "root"
})
export class DeviceService {

    private readonly mobileWidthQuery = '(max-width: 768px)';
    private _isMobile: BehaviorSubject<boolean>;
		private _isMultiWS: Subject<boolean>;

    constructor(
			private breakpointObserver: BreakpointObserver,
			private svcPlatform: PlatformService,
			private svcSnackBar: SnackbarService
		) {
				this._isMultiWS = new Subject<boolean>()
        this._isMobile = new BehaviorSubject<boolean>(this.isMobile());
        this.setupBreakpointObserver();
    }

		emitShowBandeau(isMulti : boolean) {
			this._isMultiWS.next(isMulti);
		}

    private setupBreakpointObserver(): void {
        this.breakpointObserver.observe([this.mobileWidthQuery])
            .pipe(
                map((state: BreakpointState) => state.matches)
            )
            .subscribe(isMobile => this._isMobile.next(isMobile));
    }

    private isMobile(): boolean {
        return window.matchMedia(this.mobileWidthQuery).matches;
    }

    get isMobile$(): Observable<boolean> {
        return this._isMobile.asObservable();
    }

		get _isMultiWS$(): Observable<boolean> {
			return this._isMultiWS.asObservable();
		}

		checkMobileBrowserRestriction(isMobileView: boolean): Observable<never> | null {
			if (
				!this.svcPlatform.isMobileApp &&
				isMobileView &&
				UserData.modules.includes(EModule.sce)
			) {
				this.svcSnackBar.showToast(
					'warning',
					'bottom center',
					'Cette fonctionnalité n\'est pas disponible sur un navigateur mobile. Merci de passer par l\'application disponible sur le store',
					null,
					null,
					null,
					'7000'
				);
				return EMPTY;
			}
			return null;
		}

}